import styled from '@emotion/styled';
import {
  Button,
  Container,
  Loading,
  LoadingContainer,
  ModalCloseButton,
  SectionSubtitle
} from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const MAP_BREAKPOINT = 1400;

export const FiltersContainer = styled(Container)`
  display: flex;
  margin-top: 20px;
  margin-left: auto;
  margin-right: 0;
  width: 100%;

  ${mediaQuery('tablet')} {
    margin: 10px 0;
  }
`;

export const StyledLoadingContainer = styled(LoadingContainer)`
  min-height: 900px;
`;

export const Wrapper = styled.div<{ hasMap: boolean }>`
  /* overflow: hidden; */
  /* margin-bottom: 100px; */
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ListWrapper = styled.div<{ hasMap: boolean; mobileShown: boolean }>`
  overflow: auto;
  width: ${(props) => (props.hasMap ? '70%' : '100%')};
  ${mediaQuery(MAP_BREAKPOINT)} {
    width: 100%;
    display: ${(props) => (props.mobileShown ? 'block' : 'none')};
  }
`;

export const ListCardContainerWrapper = styled(Container)<{ hasMap: boolean }>`
  width: 100%;
  padding-right: 30px;
  ${(props) =>
    props.hasMap &&
    `
  margin-right: 0;
  margin-left: auto;
  `}
`;

export const FiltersInputContainers = styled.div<{ hideOnMobile?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  z-index: 1;

  & > * {
    margin-bottom: 0px !important;
    min-width: 140px;

    ${mediaQuery('tablet')} {
      width: 100% !important;
    }

    &:not(:last-child) {
      margin-right: 25px;
      ${mediaQuery('desktop')} {
        margin-right: 10px;
      }
      ${mediaQuery('medium')} {
        margin-right: 0px;
        margin-bottom: 15px !important;
      }
    }
  }

  ${mediaQuery(1600)} {
    flex-wrap: wrap;
  }

  ${mediaQuery('tablet')} {
    flex-direction: column;
    align-items: flex-start;
    ${(props) =>
      props.hideOnMobile &&
      `
      display: none;
    `}
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 25px;
    ${mediaQuery('desktop')} {
      margin-right: 10px;
    }
  }
`;

export const ProAvatarImage = styled.img`
  object-fit: cover;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
`;

export const LinkText = styled.div`
  font-weight: 500;
  color: ${(props) => props.theme.color.blue.default};
  cursor: pointer;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;

export const UnclaimedSubtitle = styled(SectionSubtitle)`
  margin: 20px auto;
  text-align: center;
  width: 100%;
`;

// MAP
export const MapButton = styled(Button)`
  ${mediaQuery(MAP_BREAKPOINT, 'min')} {
    display: none;
  }
  ${mediaQuery('tablet')} {
    margin-left: 15px;
  }
`;

export const MapWrapper = styled.div<{ mobileShown: boolean }>`
  background: ${(props) => props.theme.color.light.shade};
  margin-top: -60px;
  z-index: 0;
  width: 30%;
  position: relative;

  ${mediaQuery(MAP_BREAKPOINT)} {
    display: ${(props) => (props.mobileShown ? 'block' : 'none')};
    /* position: absolute; */
    /* top: 0; */
    width: 100%;
    /* height: 100%; */
    min-height: 700px;
  }
`;

export const MapStickyWrapper = styled.div<{ mobileShown: boolean }>`
  ${mediaQuery(MAP_BREAKPOINT, 'min')} {
    height: calc(100vh - 80px);
    position: sticky;
    top: 80px;
  }
  ${mediaQuery(MAP_BREAKPOINT)} {
    width: 100%;
    height: 100%;
    top: 0;
  }
`;

export const MapFiltersWrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 5%);
  background: ${(props) => props.theme.color.light.default};
  padding: 25px 40px;
  position: absolute;
  left: 50px;
  right: 50px;
  top: 50px;
  z-index: 1000;

  ${mediaQuery('small')} {
    top: 0;
    left: 0;
    right: 0;
    padding: 15px 20px;
    border-radius: 0;
    padding-top: 25px;
    padding-right: 60px;
  }
`;

export const MapProCardWrapper = styled.div`
  position: absolute;
  left: 50px;
  right: 50px;
  bottom: 50px;
  z-index: 1000;

  ${mediaQuery('small')} {
    left: 20px;
    right: 20px;
    bottom: 20px;
  }
`;

export const StyledModalCloseButton = styled(ModalCloseButton)`
  z-index: 1001;
  /* right: unset;
  left: 15px; */
`;

export const MapRefreshButton = styled(Button)`
  z-index: 1000;
  left: 15px;
  top: 20px;
  position: absolute;
  ${mediaQuery(MAP_BREAKPOINT)} {
    top: 190px;
    left: 50px;
  }
  ${mediaQuery('small')} {
    transform: translateX(-50%);
    top: 125px;
    left: 50%;
  }
`;

export const MapProLoadingWrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 5%);
  background: ${(props) => props.theme.color.light.default};
  padding: 25px 40px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledLoading = styled(Loading)`
  width: 64px;
  height: 64px;
  filter: invert(88%) sepia(9%) saturate(5159%) hue-rotate(160deg) brightness(93%) contrast(96%);
`;

export const MapProSearchFormContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const MapProSearchFormButton = styled(Button)`
  margin-left: 15px;
`;
